import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import React, { useEffect, useState } from 'react';
import { getLocale, useIntl, useParams } from 'umi';
import classNames from 'classnames';
import { IConfigData } from '@/pages/dashboard/components/PageContainer/type';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';
import { getApiData } from '@/pages/benchmark/services/common';
import UnloadModal from '@home/pages/home/Explore/components/UnloadModal';

import './index.scss';

interface Iprops {
  config: {
    title: string;
    titleCn: string;
    // 获取点赞状态api
    api?: string;
    // 点赞api
    clickApi?: string;
    // 点赞状态接口返回值的key
    dataKey?: string;
  };
  data: IConfigData;
  className?: string;
  style?: React.CSSProperties;
}
// 和产品核对，进入页面如果接口报错则展示默认状态，两个都不是选中态

const defaultApi = '/api/v2/dashboard/benchmark/metric/expansion/info';
const defaultClickApi = '/api/v2/dashboard/benchmark/metric/expansion';
// 指标详情页，页面标题组件
const MetricDetailOperation = (props: Iprops) => {
  const { config, data, className, style } = props || {};
  const isEN = getLocale() === LANGUAGE_EN;
  const { title, titleCn, api = defaultApi, clickApi = defaultClickApi, dataKey = 'like' } = config || {};
  const { metric } = useParams<{ metric: string; }>();
  const [upStatus, setUpStatus] = useState(false);
  const [downStatus, setDownStatus] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const { formatMessage } = useIntl(); // 中英切换方法

  // 点击赞和踩
  const handleClick = (value: string) => {
    setStomStatusData(value);
    if(value === 'down') {
      !downStatus && setShowFeedback(!showFeedback);
    }
  };

  useEffect(() => {
    getStompStatusData();
  }, []);

  // 初始化获取数据
  const getStompStatusData = () => {
    const params = {
      frame_type: FRAME_TYPE_MAP?.[data?.frameType],
      metric,
      type: ['like'],
    };
    getApiData(api, params)?.then((response: any) => {
      // 后端约定不传值的话就是default
      const result = response?.[dataKey];
      setUpStatus(result === 'up');
      setDownStatus(result === 'down');
    }).catch((e) => {
      console.log('getStompStausData error', e);
    });
  };

  const setStomStatusData = (value: string) => {
    const  cancelFlag = (value === 'up' && upStatus) || (value === 'down' && downStatus);
    const params = {
      frame_type: FRAME_TYPE_MAP?.[data?.frameType],
      metric,
      type: 'like',
      expansion: !cancelFlag ? value : ''
    };
    getApiData(clickApi, params)?.then(() => {
      if(value === 'up') {
        setUpStatus(!upStatus);
        // 用户先点踩后改成赞，系统原来的点踩数-1，系统的赞数+1，点踩样式改为默认
        downStatus && setDownStatus(false);
      } else {
        setDownStatus(!downStatus);
        // 用户先点赞后改成踩，系统原来的点赞数-1，系统的踩数+1，点赞样式改为默认
        upStatus && setUpStatus(false);
      }
    }).catch((e) => {
      console.log('getStompStausData error', e);
    });
  };


  return (
    <div className={classNames('dbb-metric-detail-title-operation', className)} style={style}>
      <div className='dbb-metric-detail-title-operation-text'>
        {getName(isEN, title, titleCn)}
      </div>
      <div className='dbb-metric-detail-title-operation-icons'>
        <div
          className={classNames('dbb-metric-detail-title-operation-praise', { 'dbb-metric-detail-title-operation-action': upStatus })}
          onClick={() => handleClick('up')}>
          <SvgIcon type='zan' className={classNames('dbb-metric-icon', { 'action-icon': upStatus })} />
        </div>
        <div
          className={classNames('dbb-metric-detail-title-operation-stomp', { 'dbb-metric-detail-title-operation-action': downStatus})}
          onClick={() => handleClick('down')}>
          <SvgIcon type='cai' className={classNames('dbb-metric-icon',{ 'action-icon': downStatus})} />
        </div>

      </div>
      <UnloadModal
        visible={showFeedback}
        showTemplate={false}
        placeholder={formatMessage({id: 'dbb_explore_feedback_unlike_placeholder'})}
        describe={formatMessage({id: 'dbb_explore_feedback_unlike_title'})}
        infoType={103}
        close={() => {
          setShowFeedback(!showFeedback);
        }}
      />
    </div>
  );
};

export default MetricDetailOperation;
